import GridLine, { SIZE_VARIANT } from "../../../../../../../components/layouts/grid-line-layout/grid-line/grid-line";
import GridLineItem from "../../../../../../../components/layouts/grid-line-layout/grid-line/grid-line-item/grid-line-item";
import FontBody1 from "../../../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../../../components/fonts/font-props";
import FontBody3 from "../../../../../../../components/fonts/font-body3/font-body3";
import AHref from "../../../../../../../components/ahref/ahref";
import MissingShipmentValue from "../missing-shipment-value/missing-shipment-value";
import ShipmentStatusChip from "../shipment-status-chip/shipment-status-chip";
import LabelOrSlipsCell from "../label-or-slips-cell/label-or-slips-cell";
import RmaShipmentStore from "../../../../stores/rma-shipment-store";
import RmaPageStore from "../../../../stores/rma-page-store";
import SlipsCell from "../slips-cell/slips-cell";
import QRCell from "../qr-cell/qr-cell";
import FontBody2 from "../../../../../../../components/fonts/font-body2/font-body2";
import useDashboardTranslation from "../../../../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface IDropOffLocationGridProps {
    isStatusDisplayed: boolean;
    location?: string | null;
    shipment: RmaShipmentStore;
    rmaPageStore: RmaPageStore;
}

const DropOffLocationGridWithIntegration: React.FC<IDropOffLocationGridProps> = ({ isStatusDisplayed, shipment, rmaPageStore }) => {
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-returns-rma-card';
    const TrackingNumberLabel = shipment.isOutboundShipment ? getTranslation('SHIPMENT_COLUMN_TITLE_FOR_OUTBOUND_SHIPMENT', pageScope) : getTranslation('SHIPMENT_COLUMN_TITLE_FOR_TRACKING_NUMBER', pageScope);

    return (
        <GridLine
            settings={{
                columns: [{ width: shipment.isOutboundShipment ? 2.5 : 3 }, { width: 3 }, { width: 1.5 }, { width: 2 }, { width: 2 }, { width: 2 }, { width: 3 }, { width: 2.5 }]
            }}
            sizeVariant={shipment.isOutboundShipment ? SIZE_VARIANT.SMALL : SIZE_VARIANT.DEFAULT}
            columns={[
                <GridLineItem>
                    {shipment.isOutboundShipment
                        ? <FontBody2 color={FONT_COLOR.PRIMARY2} variant={[FONT_VARIANT.BOLD]}>{getTranslation('SHIPMENT_COLUMN_TITLE_FOR_OUTBOUND_SHIPMENT', pageScope)}</FontBody2>
                        : <FontBody1 color={FONT_COLOR.PRIMARY2} variant={[FONT_VARIANT.BOLD]}>{shipment.returnMethodName}</FontBody1>
                    }
                </GridLineItem>,

                <GridLineItem>
                    <FontBody3 color={FONT_COLOR.PRIMARY2} variant={[FONT_VARIANT.BOLD]}>{getTranslation('SHIPMENT_COLUMN_TITLE_FOR_CARRIER', pageScope)}</FontBody3>
                    <FontBody3 color={FONT_COLOR.PRIMARY3_50}>
                        {shipment.carrier
                            ? (
                                <div className="shipping-aggregator-with-icon">
                                    {shipment.integrationLogoIconUrl && <img src={shipment.integrationLogoIconUrl} alt={shipment.carrier} width={16} height={16} />}
                                    {shipment.carrier}
                                </div>
                            )
                            : (
                                <MissingShipmentValue rmaPageStore={rmaPageStore} />
                            )}
                    </FontBody3>
                </GridLineItem>,

                <GridLineItem>
                    <QRCell QRImage={shipment.QRImage} />
                </GridLineItem>,

                <GridLineItem>
                    <LabelOrSlipsCell content={shipment.labelContent()} rmaPageStore={rmaPageStore} />
                </GridLineItem>,

                <GridLineItem>
                    <FontBody3 color={FONT_COLOR.PRIMARY2} variant={[FONT_VARIANT.BOLD]}>{TrackingNumberLabel}</FontBody3>
                    {!!shipment.trackingUrl
                        ? (
                            <AHref href={shipment.trackingUrl} target="_blank">
                                <FontBody3 color={FONT_COLOR.ACCENT1}>{shipment.trackingNumber ?? <MissingShipmentValue rmaPageStore={rmaPageStore} />}</FontBody3>
                            </AHref>
                        )
                        : (
                            <div className="shipment-label-with-warning">
                                <FontBody3 color={FONT_COLOR.PRIMARY3_50}>{shipment.trackingNumber ?? <MissingShipmentValue rmaPageStore={rmaPageStore} />}</FontBody3>
                            </div>
                        )
                    }
                </GridLineItem>,

                <GridLineItem>
                    <SlipsCell shipment={shipment} rmaPageStore={rmaPageStore} />
                </GridLineItem>,

                <GridLineItem>
                    <FontBody3 color={FONT_COLOR.PRIMARY2} variant={[FONT_VARIANT.BOLD]}>{getTranslation('SHIPMENT_COLUMN_TITLE_FOR_ITEMS', pageScope)}</FontBody3>
                    <FontBody3 color={FONT_COLOR.PRIMARY3_50}>{shipment.numberOfItems > 0 ? shipment.numberOfItems : getTranslation('DATA_VALUE_NOT_APPLICABLE', pageScope)}</FontBody3>
                </GridLineItem>,

                <GridLineItem>
                    {isStatusDisplayed ? (
                        <FontBody3 color={FONT_COLOR.PRIMARY3_50}>
                            {shipment.status
                                ? <ShipmentStatusChip status={shipment.status} statusCode={shipment.statusCode} />
                                : <MissingShipmentValue rmaPageStore={rmaPageStore} />
                            }</FontBody3>
                    ) : <></>}
                </GridLineItem>
            ]} />
    );
};

export default DropOffLocationGridWithIntegration;